export default __webpack_public_path__ + "static/media/art-pro-slt-banner-3.c509c011.jpg";